"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


// The server refuses a staff text to a new patient once an unverified account
// has reached its contact cap (apps/backend/pkg/bloom/command/contact_cap.go).
// The refusal carries ErrorCode "contact_cap_reached" and the numbers for the
// copy. A refused message stays failed; this keeps why, per message, outside
// the store so the conversation rows don't need a new field.

 const CONTACT_CAP_REACHED = 'contact_cap_reached'; exports.CONTACT_CAP_REACHED = CONTACT_CAP_REACHED
 const BLOOMTEXT_SUPPORT_EMAIL = 'support@bloomtext.com'; exports.BLOOMTEXT_SUPPORT_EMAIL = BLOOMTEXT_SUPPORT_EMAIL
 const BLOOMTEXT_SUPPORT_URL = `mailto:${exports.BLOOMTEXT_SUPPORT_EMAIL}`; exports.BLOOMTEXT_SUPPORT_URL = BLOOMTEXT_SUPPORT_URL






/** The refusal's numbers when an error is the contact cap, otherwise null. */
 const contactCapBlockFromError = (error) => {
  if (!error || typeof error !== 'object') return null
  const e = error 
  // wsCommand rethrows client errors as a CommandError carrying the response.
  const data = (e.extra && typeof e.extra === 'object' ? e.extra : e) 
  if (data.ErrorCode !== exports.CONTACT_CAP_REACHED) return null
  return { used: Number(data.Used) || 0, cap: Number(data.Cap) || 0 }
}; exports.contactCapBlockFromError = contactCapBlockFromError

 const contactCapBlockedLabel = ({ cap }) =>
  "This message wasn't sent. New accounts can text up to " +
  `${cap} different patients per billing period until BloomText verifies them, ` +
  "and you've reached that limit. You can keep messaging patients you've already texted this period."; exports.contactCapBlockedLabel = contactCapBlockedLabel



const entries = new Map()
const listeners = new Map()

const notify = (key) => _optionalChain([listeners, 'access', _ => _.get, 'call', _2 => _2(key), 'optionalAccess', _3 => _3.forEach, 'call', _4 => _4(listener => listener())])

 const contactCapBlockStore = {
  get: (key) => entries.get(key),

  set: (key, block) => {
    if (block) entries.set(key, block)
    else if (!entries.delete(key)) return
    notify(key)
  },

  subscribe: (key, listener) => {
    let set = listeners.get(key)
    if (!set) {
      set = new Set()
      listeners.set(key, set)
    }
    set.add(listener)
    return () => {
      _optionalChain([set, 'optionalAccess', _5 => _5.delete, 'call', _6 => _6(listener)])
      if (_optionalChain([set, 'optionalAccess', _7 => _7.size]) === 0) listeners.delete(key)
    }
  },
}; exports.contactCapBlockStore = contactCapBlockStore

/** Why this message was refused by the contact cap, if it was. */
 const useContactCapBlock = (key) => {
  const subscribe = _react.useCallback.call(void 0, 
    (listener) => (key ? exports.contactCapBlockStore.subscribe(key, listener) : () => undefined),
    [key],
  )
  const getSnapshot = _react.useCallback.call(void 0, () => (key ? exports.contactCapBlockStore.get(key) : undefined), [key])
  return _react.useSyncExternalStore.call(void 0, subscribe, getSnapshot, getSnapshot)
}; exports.useContactCapBlock = useContactCapBlock
